import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";

import { MatSelect } from "@angular/material/select";
import { Entity } from "@app/entity/model/entity";

@Component({
    selector: "subdealer-selector",
    templateUrl: "./subdealer-selector.component.html",
    styleUrls: ["./subdealer-selector.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubdealerSelectorComponent implements OnChanges {
    @ViewChild("selectDealer", { static: false }) selectDealer: MatSelect;
    @ViewChild("selectDealer", { read: ElementRef }) selectDealerRef: ElementRef;

    @Input() subdealers: Entity[];
    @Output() selectionMade: EventEmitter<any> = new EventEmitter();
    @Input() selectedEntityId;
    public entityModel: { [key: string]: number } | "" = "";

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.subdealers?.currentValue) {
            this.entityModel = changes.subdealers.currentValue.find(subdealer => subdealer.id === this.selectedEntityId) || "";
            this.setMatSelectWidth();
        }
    }

    selectEntity($event) {
        this.selectionMade.emit($event);
        this.setMatSelectWidth();
    }

    private setMatSelectWidth(): void {
        requestAnimationFrame(() => {
            const matSelectElement = this.selectDealerRef?.nativeElement;

            // drill down to just the text element and get the width
            const textElementWidth = this.selectDealerRef?.nativeElement?.querySelector(".mat-select-min-line")?.offsetWidth;

            // set the width of the matSelectElement based off the width of the text
            if (textElementWidth) {
                matSelectElement.style.maxWidth = `${textElementWidth + 20}px`;
            }
        });
    }
}
